import React, { Suspense, useEffect } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "react-phone-input-2/lib/style.css";
import "react-quill/dist/quill.snow.css";
import "./scss/main.scss";
import configureStoreProd from "./Pages/config/configureStore.prod";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ToastContainer } from "react-toastify";
import { ConfigProvider } from "antd";
import { brand } from "./brand";
import { lazy } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "./Pages/actions/user";
import { useNavigate } from "react-router-dom";

const { persistor, store } = configureStoreProd();

const PageRoute = ({ children, auth }: any) => {
  const user = useSelector((state: any) => state.user);
  const dispatch = useDispatch()
  const history = useNavigate();
  const Logout = () => {
    dispatch(logout());
    sessionStorage.removeItem("persist:admin-app");
    sessionStorage.removeItem("token");
    // localStorage.removeItem("loginTime")
    history("/login");
  };
  useEffect(() => {
    if (!user?.loggedIn && auth) {
      Logout()
    }
  }, []);
  const noAccess = (auth && !user?.loggedIn)
  if (noAccess) return <></>
  return <>
    {children}</>
}


function App() {

  const routes = [
    { url: "/login", path: "Login", noAuth: true },
    { url: "/signup", path: "Signup", noAuth: true },
    { url: "/dashboard", path: "Dashboard" },
    { url: "*", path: "NotFoundPage", noAuth: true },
    { url: "/profile", path: "Profile" },
    { url: "/profile/:tab", path: "Settings" },
    { url: "/forgotpassword", path: "Forgotpassword", noAuth: true },
    { url: "/resetpassword", path: "Resetpassword", noAuth: true },
    { url: "/quote", path: "Quote" },
    { url: "/Quote/add/:quoteId?", path: "Quote/AddEdit" },
    { url: "/quote/edit/:id", path: "Quote/AddEdit" },
    { url: "/Quote/detail/:id", path: "Quote/View" },
    { url: "/Quote/summary/:id", path: "Quote/QuoteSummary" },
    { url: "/query", path: "CustomerSupport" },
    { url: "/query/add", path: "CustomerSupport/SendQuery" },
    { url: "/concern/add", path: "CustomerSupport/SendConcern" },
    { url: "/concern/edit/:id", path: "CustomerSupport/SendConcern" },
    { url: "/query/edit/:id", path: "CustomerSupport/SendQuery" },
    { url: "/query/detail/:id", path: "CustomerSupport/View" },
    { url: "/orders", path: "Orders" },
    { url: "/orders/view/:id", path: "Orders/View" },
    { url: "/invoice", path: "Invoice" },
    { url: "/invoice/detail/:id", path: "Invoice/View" },
    { url: "/notification", path: "Notification" },
     { url: "/contactpermission", path: "ContactPermission" },
    { url: "/contactpermission/add/:quoteId?", path: "ContactPermission/AddEdit" },
    { url: "/contactpermission/edit/:id", path: "ContactPermission/AddEdit" },
    { url: "/contactpermission/detail/:id", path: "ContactPermission/View" },
    { url: "/branding", path: "Branding" },
    { url: "/customers", path: "B2B2CCustomers" },
    { url: "/price-tiers", path: "PriceTiers" },
    { url: "/custom-items", path: "CustomItems" },
    { url: "/customer-quotes", path: "CustomerQuotes" },
    { url: "/help", path: "B2B2CHelp" },

    { url: "/", element: <Navigate to="/login" />, noAuth: true },
  ];
  sessionStorage.removeItem('activeRooms');

  const loaderClass = `loaderlogo${brand.assets.loaderPulse ? " loaderlogo--pulse" : ""}`;

  return (
    <ConfigProvider theme={brand.antd || undefined}>
      <Provider store={store}>
        <PersistGate loading={"loading ..."} persistor={persistor}>
          <Suspense
            fallback={
              <div id="loader" className="loaderDiv">
                <div>
                  <img
                    src={brand.assets.loader}
                    alt="logo"
                    className={loaderClass}
                  />
                </div>
              </div>
            }
          >
            <Router>
              <Routes>
                {routes.map((itm) => {
                  const Element = lazy(() => import(`./Pages/${itm.path}`));
                  return (
                    <Route
                      path={itm.url}
                      element={itm.path ? <PageRoute auth={itm?.noAuth ? false : true}><Element /></PageRoute> : itm.element}
                    />
                  );
                })}
              </Routes>
            </Router>
          </Suspense>
        </PersistGate>
      </Provider>
      <div id="loader" className="loaderDiv d-none">
        <div>
          <img src={brand.assets.loader} alt="logo" className={loaderClass} />
        </div>
      </div>
      <ToastContainer position="top-right" />
    </ConfigProvider>
  );
}

export default App;
